module.exports = __webpack_public_path__ + "static/ticker-73a6b0ee2ca662dc5b53b583b50b47e2.jpg";